export default "__VITE_ASSET__C6homz1u__"